<ng-content></ng-content>
<container-element [ngSwitch]="table.sortBy">
  <i *ngSwitchCase="'-' + sortBy" class="hidden-print material-symbols-rounded">sort</i>
  <!-- The invisble class hides the icon but keeps the space to avoid columns resizing. -->
  <i *ngSwitchDefault [class.invisible]="table.sortBy !== sortBy" class="hidden-print material-symbols-rounded flip-vertical">sort</i>
</container-element>